var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "rgsgame-game-backgroundimage",
      style: { backgroundImage: "url(" + _vm.gameimage + ")" }
    },
    [
      _c("div", { staticClass: "rgsgame-game-details-container" }, [
        _c("div", { staticClass: "flex-between" }, [
          _c("h2", [_vm._v(_vm._s(_vm.gamename))]),
          _vm._v(" "),
          _c("img", {
            staticClass: "rgsgame-game-logo",
            attrs: { src: _vm.gamelogo }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "game-description" }, [
          _c("p", [_vm._v(_vm._s(_vm.gamedescription))])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c6082a92", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6082a92","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gap/GameDetails.vue
// module id = null
// module chunks = 